/**
 * Centralized API endpoints - single source of truth for all API paths.
 * Use these constants instead of hardcoded strings for easier maintenance.
 */

// Auth
export const AUTH = {
  PROFILE: '/auth/profile',
  LOGIN: '/auth/login',
  LOGOUT: '/auth/logout',
  PROFILE_UPDATE: '/auth/profile-update',
  FORGOT_PASSWORD: '/auth/forgot-password',
  RESET_PASSWORD: '/auth/reset-password',
  MEETINGS: '/auth/meetings',
};

// Users
export const USERS = {
  LIST: '/users',
  BY_ID: (id) => `/users/${id}`,
  BY_ROLE: (role) => `/users/by-role?role=${role}`,
  DIRECT_PERMISSIONS: (userId) => `/users/${userId}/direct-permissions`,
};

// Roles
export const ROLES = {
  LIST: '/roles',
  BY_ID: (roleId) => `/roles/${roleId}`,
};

// Permissions
export const PERMISSIONS = {
  LIST: '/permissions?paginate=0',
};

// Statuses
export const STATUSES = {
  LIST: '/statuses',
  BY_MODEL: (model) => `statuses?conditions[model]=${model}`,
};

// Notifications
export const NOTIFICATIONS = {
  UNREAD: '/notifications/unread',
  BY_ID: (id) => `/notifications/${id}`,
  MARK_ALL_READ: '/notifications/mark-all-read',
};

// DBAs / Merchants
export const DBAS = {
  LIST: '/dbas',
  BY_ID: (id) => `/dbas/${id}`,
  PROCESS_STATUS: (id) => `/dbas/${id}/process-status`,
  STATUS: (id) => `/dbas/${id}/status`,
  REASSIGN: (id) => `/dbas/${id}/reassign`,
};

// Leads
export const LEADS = {
  LIST: '/leads',
  BY_ID: (id) => `/leads/${id}`,
  IMPORT: '/leads/import',
  UPDATE_STATUS: (id) => `/leads/${id}/update-status`,
  ASSIGN_USER: (id) => `/leads/${id}/assign-user`,
  ASSIGNED_USERS: (id) => `/leads/${id}/assigned-users`,
  DOWNLOAD: '/leads/download',
};

// Shareable links
export const SHAREABLE_LINKS = {
  CREATE: '/shareable-links',
};

// Issues
export const ISSUES = {
  LIST: '/issues',
  BY_ID: (id) => `/issues/${id}`,
  CREATE: '/issues',
  UPDATE_STATUS: (id) => `/issues/${id}/update-status`,
  ASSIGN_USER: (id) => `/issues/${id}/assign-user`,
  ASSIGNED_USERS: (id) => `/issues/${id}/assigned-users`,
};

// Teams
export const TEAMS = {
  BASE: '/teams',
  LIST: '/teams?relations[0]=members&relations[1]=status',
  BY_ID: (id) => `/teams/${id}`,
};

// Prospects
export const PROSPECTS = {
  LIST: '/prospects',
  BY_ID: (id) => `/prospects/${id}`,
  CONVERT: (id) => `/prospects/${id}/convert`,
  STATS: '/prospects/stats',
  SEARCH: '/prospects/search',
};

// Meetings
export const MEETINGS = {
  LIST: '/meetings',
  BY_ID: (id) => `/meetings/${id}`,
  UPDATE_STATUS: (id) => `/meetings/${id}/update-status`,
};

// Dashboard
export const DASHBOARD = {
  TOTAL: '/dashboards/total',
};

// Activity logs
export const ACTIVITY_LOGS = {
  LIST: '/activity-logs',
  BY_ID: (id) => `/activity-logs/${id}`,
};

// Attachments / Documents
export const ATTACHMENTS = {
  LIST: '/attachments',
  BY_ID: (id) => `/attachments/${id}`,
  DOWNLOAD: (id) => `/attachments/${id}/download`,
  DOWNLOAD_BY_PATH: '/attachments/download',
};

// Lookup / Reference data
export const LOOKUP = {
  COUNTRIES: '/countries',
  COUNTRY_BY_ID: (id) => `/countries/${id}`,
  ATTRIBUTE_TYPES: '/attribute-types',
  EQUIPMENT_TYPES: '/equipment-types',
  EQUIPMENT_MODELS: '/equipment-models',
  MANUFACTURERS: '/manufacturers',
  BANKRUPT_TYPES: '/bankrupt-types',
  SOURCES: '/sources',
  BRANDS: '/brands',
};


export const Equipments = {
  LIST: '/equipments',
  GETEQUIPMENTDBA: () => `/equipments/merchant-equipments`,
  BY_ID: (id) => `/equipments/${id}`,
  STATUS: (id) => `/equipments/${id}/status`,
  EQUIPMENT_LOGS: (id) => `/equipments/${id}/equipment-logs`,
};

// E-Sign Templates (for Create Contract form)
export const E_SIGN_TEMPLATES = {
  LIST: '/e-sign-templates?relations[0]=status&relations[1]=author',
};

// E-Sign Contracts (listing, create, actions)
export const E_SIGN_CONTRACTS = {
  LIST: '/e-sign-contracts',
  CREATE: '/e-sign-contracts',
  BY_ID: (id) => `/e-sign-contracts/${id}`,
  /** POST /e-sign-contracts/:id/resend_sign_request?signer_api_id= */
  RESEND: (contractId, signerApiId) =>
    `/e-sign-contracts/${contractId}/resend_sign_request${signerApiId ? `?signer_api_id=${encodeURIComponent(signerApiId)}` : ''}`,
  /** GET /e-sign-contracts/:id/download?sign_page_url=... — backend fetches PDF from sign URL */
  DOWNLOAD: (id, signPageUrl) =>
    `/e-sign-contracts/${id}/download${signPageUrl ? `?sign_page_url=${encodeURIComponent(signPageUrl)}` : ''}`,
  SIGN_URL: (id) => `/e-sign-contracts/${id}/sign-url`,
};